// extracted by mini-css-extract-plugin
export var active = "_jk-2";
export var recordingDot = "_jk-1";
export var recordingIndicator = "_jk-0";